import React from "react";

import PageError from "src/components/Errors/PageError.tsx";
import { emitReload } from "src/hooks/useEvents.ts";
import { useT } from "src/internationalization";

const Page500: React.FC = () => {
  const t = useT();

  return (
    <PageError
      title={t("page.server.error.title")}
      description={t("page.server.error.description")}
      onClick={() => emitReload()}
    />
  );
};

export default Page500;
